// extracted by mini-css-extract-plugin
export default {"blmContainer":"xW_xX","blmDiceContainer":"xW_xY","dice":"xW_wV"};